import moment from "moment";
import Sortable from "sortablejs";
import store from "../store/index";
import { ossUpload } from './oss'
import { getOssAuth } from "../api/index"

// 时间格式化
const getFormat = function (value, format) {
  if (format === "time") {
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
  } else if (format === "month") {
    return moment(value).format("YYYY-MM");
  }
};

const getFormatAmount = function (value) {
 if (value === null || value === undefined || value === '') return ''
  
  let num = parseFloat(value)
  if (isNaN(num)) return value
  
  // 判断是否为整数
  if (Number.isInteger(num)) {
    // 整数：千分位格式化，不显示小数部分
    return num.toLocaleString('zh-CN')
  } else {
    // 小数：千分位格式化，保留2位小数，去除末尾的0
    let parts = num.toLocaleString('zh-CN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).split('.')
    
    // 处理小数部分，去除末尾的0
    let decimalPart = parts[1].replace(/0+$/, '')
    
    if (decimalPart === '') {
      return parts[0] // 如果没有小数部分，只返回整数部分
    } else {
      return parts[0] + '.' + decimalPart
    }
  }
};
// 

const createSortTable = (
  element,
  onStart = () => { },
  callback = () => { },
  draggable = ".ant-table-row"
) => {
  return new Sortable(element, {
    animation: 150,
    sort: true,
    draggable,
    disabled: false,
    handle: ".moveButton",
    // dragClass: 'sortableDrag',
    // ghostClass: 'sortableDrag',
    forceFallback: true,
    fallbackClass: "sortableDrag",
    onStart: function () {
      onStart();
    },
    onEnd: function (evt) {
      let oldIndex = evt.oldIndex;
      let newIndex = evt.newIndex;
      callback(oldIndex, newIndex);
    },
  });
};

// 211
const determineLimitsAuthority = (data) => {
  return (
    store.getters.getUserInfo.rolePermissionsNew.split(";").indexOf(data) > -1
  );
};
/*
  生成wang编辑器
    element: String 容器,
    menus: Array 菜单
 */
const createEdit = (element, menus = []) => {
  const menusList = menus.length ? menus : [
    'head', // 标题
    'bold', // 粗体
    'fontSize', // 字号
    'fontName', // 字体
    'italic', // 斜体
    'underline', // 下划线
    'strikeThrough', // 删除线
    'foreColor', // 文字颜色
    'backColor', // 背景颜色
    // 'link', // 插入链接
    // 'list', // 列表
    'justify', // 对齐方式
    'quote', // 引用
    'image', // 插入图片
    // 'video', //视频
    // 'table', // 表格
    // 'code', // 插入代码
    'undo', // 撤销
    'redo' // 重复
  ]
  const edit = new E(element)
  edit.config.zIndex = 100
  edit.config.menus = menusList
  edit.config.customUploadImg = async (files, insert) => {
    const form = new FormData();
    form.append("file", files[0]);
    const res = await getOssAuth(form)
    insert(res.resultData.fileLink)
    // insert("http://yin-api.aceclound.cn/upload/images/20250324/0d3c5c9c927e463ca0aafbce2c76bc05.png")
    
    // const res = await ossUpload(files[0])
    // insert(res.url)
  }
  // 上传视频
  edit.config.customUploadVideo = async (files, insert) => {
    const suffix = files[0].name.split(`.`)[files[0].name.split(`.`).length - 1];
    const name =
      Math.random()
        .toString(32)
        .substring(3) +
      Date.now() +
      `.${suffix}`;
    const FD = new FormData()
    FD.append('file', files[0])
    store
      .dispatch('getUpload', FD)
      .then((res) => {
        if (res.resultStatus && res.resultData) {
          insert(res.resultData.fileLink)
        } else {
          this.$message.warn(res.errorMessage)
        }
      })
      .catch((err) => {
        this.$message.error(JSON.stringify(err))
      })
  }
  edit.create()
  return edit
}
const downLoadPDF = async (pdfUrl, fileName, suffix) => {
  const url = pdfUrl + '?response-content-type=application/octet-stream' // 支持跨域下载
  const name = fileName + '.' + suffix // 自定义文件名
  const a = await document.createElement('a')
  a.href = url
  a.download = name // 下载后文件名
  a.style.display = 'none'
  a.target = '_blank'
  document.body.appendChild(a)
  a.click() // 点击下载
  // document.body.removeChild(a) // 下载完成移除元素
  setTimeout(() => document.body.removeChild(a), 1000)
}
// 获取文件名
const getFileNameByUrl = (url) => {
  const filename = url.split('/').pop();
  return filename
}
const convertRes2Blob = (data, name = '导出数据', suffix = 'xlsx') => {
  const filename = name + '.' + suffix
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement("a")
  link.style.display = "none"
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
}
const downLoadFile = async (fileUrl, fileName) => {
  const url = fileUrl + '?response-content-type=application/octet-stream' // 支持跨域下载
  const a = await document.createElement('a')
  a.href = url
  a.download = fileName // 下载后文件名
  a.style.display = 'none'
  a.target = '_blank'
  document.body.appendChild(a)
  a.click() // 点击下载
  // document.body.removeChild(a) // 下载完成移除元素
  setTimeout(() => document.body.removeChild(a), 1000)
}
export { getFormat, createSortTable, determineLimitsAuthority, createEdit, downLoadPDF, convertRes2Blob,downLoadFile,getFileNameByUrl,getFormatAmount };
